<template>
  <div class="main-layout">
    <Navbar
      :loginActive="true"
      :showLinks="true"
      :showAdminLink="isAdmin"
      @logout="logout" />

    <br/>

    <router-view />
  </div>
</template>

<script>

import Navbar from "@/components/Navbar.vue";
import shared from '@/utils.js';

export default {
  name: "Main",
  components: {
    Navbar
  },
  data: function () {
    return {
      user: {
        role: "customer"
      }
    }
  },
  methods: {
    logout () {
      localStorage.removeItem("backendToken");

      this.$router.push("login");

      this.$buefy.toast.open({
        duration: 3000,
        message: this.$t("misc.logoutMessage"),
        position: "is-top",
        type: "is-success"
      });
    }
  },
  mounted: function () {
    let view = this;

    if (window.localStorage.backendToken == null && this.$route.name != "login") {
      // The user is not logged in
      this.$router.push("login");
    }

    // Retrieve the current user, used to choose which
    // navbar links should be displayed
    shared.getCurrentUser(function (user) {
      view.user = user;

      // Update the local language with the user's preferred one
      view.$i18n.locale = user.language;
      localStorage.language = user.language;
    }, function (err) {
      console.log(err);
    });
  },
  computed: {
    isAdmin: function () {
      return this.user.role == "admin";
    }
  }
};

</script>

<style>

#app {
    margin-top: 0px;
}

</style>